export default "/images/NEJM.svg?166667e91992a5212bc723b03e45d39f";